import React from 'react';
import ColTip from '@/components/Tip';

export const content = (
  <>
    “Topic(m/n)”表示：
    <li>1. “m”是所有分区主题的分区总数加上非分区主题的数量。 </li>
    <li>2.“n”是分区主题的数量（仅计算主题本身，不包括各个分区）加上非分区主题的数量。 </li>
    <li>例如，若有一个3分区的主题和一个非分区主题，则显示为“Topic(4/2)”。</li>
    <li>
      注意，对于总览视图里的主题数量均包含了 System Topic
      的数量，而表格视角默认仅呈现用户创建的主题。
    </li>
  </>
);

export default function TopicTip({ children }) {
  return <ColTip content={content}>{children}</ColTip>;
}
